export default "__VITE_ASSET__c4badf12__"